const POBOX_EN = /\b(?:p\.?\s*o\.?\s*box|post\s+office\s+box|postal\s+box|box)[\s.#-]*\d/i
const POBOX_FR = /\b(?:case\s+postale|bo[îi]te\s+postale|c\.?\s*p\.?|b\.?\s*p\.?)[\s.#-]*\d/i
const POBOX_DE = /\bpostfach[\s.#-]*\d/i
const POBOX_PL = /\b(?:skrytka(?:\s+pocztowa)?|skr\.?\s*poczt\.?)[\s.#-]*\d/i
const POBOX_NL = /\bpostbus[\s.#-]*\d/i
const POBOX_ES = /\b(?:apartado(?:\s+(?:postal|de\s+correos))?|apdo\.?|casilla)[\s.#-]*\d/i
const POBOX_KO = /사서함[\s.#-]*\d/
const POBOX_ZH = /(?:邮政信箱|信箱)[\s.#-]*\d/
const POBOX_JA = /私書箱[\s.#-]*\d/

const POBOX_PATTERNS: RegExp[] = [
  POBOX_EN,
  POBOX_FR,
  POBOX_DE,
  POBOX_PL,
  POBOX_NL,
  POBOX_ES,
  POBOX_KO,
  POBOX_ZH,
  POBOX_JA,
]

const POBOX_VALIDATION_EXCLUDED_COUNTRIES: string[] = ['AU']

export const containsPoBoxForCountry = (value: string, countryCode: string): boolean => {
  if (!value || !countryCode) return false
  if (POBOX_VALIDATION_EXCLUDED_COUNTRIES.includes(countryCode)) return false
  return POBOX_PATTERNS.some(pattern => pattern.test(value))
}
